:host {
  // default spacing for form and layout elements
  ::slotted(.layout_column > .stzh-fieldset-row > .stzh-fieldset-row),
  ::slotted(.stzh-fieldset-row > .stzh-fieldset-row),
  ::slotted(.layout_column > .stzh-fieldset-row),
  ::slotted(.stzh-fieldset-row),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-input),
  ::slotted(.stzh-fieldset-row > stzh-input),
  ::slotted(stzh-input),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-datepicker),
  ::slotted(.stzh-fieldset-row > stzh-datepicker),
  ::slotted(stzh-datepicker),
  ::slotted(.stzh-fieldset-row > stzh-dropdown),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-dropdown),
  ::slotted(stzh-dropdown),
  ::slotted(.stzh-fieldset-row > stzh-fieldset),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-fieldset),
  ::slotted(stzh-fieldset),
  ::slotted(.stzh-fieldset-row > stzh-upload),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-upload),
  ::slotted(stzh-upload),
  ::slotted(.stzh-fieldset-row > stzh-checkbox),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-checkbox),
  ::slotted(stzh-checkbox),
  ::slotted(.stzh-fieldset-row > stzh-checkboxgroup),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-checkboxgroup),
  ::slotted(stzh-checkboxgroup),
  ::slotted(.stzh-fieldset-row > stzh-radio),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-radio),
  ::slotted(stzh-radio),
  ::slotted(.stzh-fieldset-row > stzh-radiogroup),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-radiogroup),
  ::slotted(stzh-radiogroup),
  ::slotted(.stzh-fieldset-row > stzh-row),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-row),
  ::slotted(stzh-row),
  ::slotted(.stzh-fieldset-row > stzh-vspace),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-vspace),
  ::slotted(stzh-vspace),
  ::slotted(.stzh-fieldset-row > stzh-hspace),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-hspace),
  ::slotted(stzh-hspace),
  ::slotted(.stzh-fieldset-row > stzh-text),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-text),
  ::slotted(stzh-text) {
    @include spaceCurve("margin-bottom", "tiny");
    @include mq($to: medium) {
      @include spaceCurve("margin-bottom", "small");
    }
  }

  ::slotted(.stzh-fieldset-row > stzh-fieldset),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-fieldset),
  ::slotted(stzh-fieldset) {
    @include spaceCurve("margin-top", "regular");

    .stzh-fieldset__legend {
      @include fontCurve("p1", "heading");
    }
  }

  & > .section > stzh-chipgroup,
  & > stzh-chipgroup,
  & > .section > stzh-chipselect,
  & > stzh-chipselect {
    margin-bottom: space("xlarge");
  }

  ::slotted(.stzh-fieldset-row > stzh-daterange),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-daterange),
  ::slotted(stzh-daterange) {
    @include spaceCurve("margin-bottom", "tiny");
    @include mq($to: medium) {
      margin-bottom: calc(
        #{$fieldsetDescriptionMinHeight} + #{spaceCurveValue("tiny")}
      );
    }
  }

  ::slotted(.stzh-fieldset-row > stzh-message),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-message),
  ::slotted(stzh-message) {
    @include spaceCurve("margin-bottom", "large");
  }

  ::slotted(.stzh-fieldset-row > stzh-actions),
  ::slotted(.layout_column > .stzh-fieldset-row > stzh-actions),
  ::slotted(stzh-actions) {
    @include spaceCurve("margin-top", "medium");
    @include spaceCurve("margin-bottom", "big");
  }

  ::slotted(*) {
    stzh-checkboxgroup stzh-checkbox,
    stzh-radiogroup stzh-radio {
      --stzh-description-min-height: none;
    }
  }

  ::slotted(.stzh-fieldset-row > :last-child),
  ::slotted(.layout_column > .stzh-fieldset-row > :last-child),
  ::slotted(:last-child),
  ::slotted(.layout_column > .stzh-fieldset-row:has(cq) > :nth-last-child(2)),
  ::slotted(.stzh-fieldset-row:has(cq) > :nth-last-child(2)) {
    margin-bottom: 0;
  }

  ::slotted(stzh-row) {
    @include mq($to: small) {
      margin-bottom: 0;
    }
    @include mq($from: small, $to: medium) {
      margin-bottom: 0;
    }
  }

  /* Slotted cells and rows */

  ::slotted(stzh-row > stzh-cell[span-large] > stzh-input),
  ::slotted(stzh-row > stzh-cell[span-large] > stzh-datepicker),
  ::slotted(stzh-row > stzh-cell[span-large] > stzh-upload),
  ::slotted(stzh-row > stzh-cell[span-large] > stzh-checkbox),
  ::slotted(stzh-row > stzh-cell[span-large] > stzh-checkboxgroup),
  ::slotted(stzh-row > stzh-cell[span-large] > stzh-dropdown),
  ::slotted(stzh-row > stzh-cell[span-large] > stzh-radio),
  ::slotted(stzh-row > stzh-cell[span-large] > stzh-amount),
  ::slotted(stzh-row > stzh-cell[span-large] > stzh-radiogroup) {
    @include mq($to: large) {
      @include spaceCurve("margin-bottom", "tiny");
    }
  }

  ::slotted(stzh-row > stzh-cell[span-medium] > stzh-input),
  ::slotted(stzh-row > stzh-cell[span-medium] > stzh-datepicker),
  ::slotted(stzh-row > stzh-cell[span-medium] > stzh-upload),
  ::slotted(stzh-row > stzh-cell[span-medium] > stzh-checkbox),
  ::slotted(stzh-row > stzh-cell[span-medium] > stzh-checkboxgroup),
  ::slotted(stzh-row > stzh-cell[span-medium] > stzh-dropdown),
  ::slotted(stzh-row > stzh-cell[span-medium] > stzh-radio),
  ::slotted(stzh-row > stzh-cell[span-medium] > stzh-amount),
  ::slotted(stzh-row > stzh-cell[span-medium] > stzh-radiogroup) {
    @include mq($to: medium) {
      @include spaceCurve("margin-bottom", "tiny");
    }
  }

  ::slotted(stzh-row > stzh-cell[span-small] > stzh-input),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-datepicker),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-upload),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-checkbox),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-checkboxgroup),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-dropdown),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-radio),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-amount),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-radiogroup) {
    @include mq($from: small, $to: medium) {
      @include spaceCurve("margin-bottom", "small");
    }
  }

  ::slotted(stzh-row > stzh-cell[span-small] > stzh-input),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-datepicker),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-upload),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-checkbox),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-checkboxgroup),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-dropdown),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-radio),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-amount),
  ::slotted(stzh-row > stzh-cell[span-small] > stzh-radiogroup) {
    @include mq($to: small) {
      @include spaceCurve("margin-bottom", "small");
    }
  }

  ::slotted(stzh-row[span-large] > stzh-cell > stzh-input),
  ::slotted(stzh-row[span-large] > stzh-cell > stzh-datepicker),
  ::slotted(stzh-row[span-large] > stzh-cell > stzh-upload),
  ::slotted(stzh-row[span-large] > stzh-cell > stzh-checkbox),
  ::slotted(stzh-row[span-large] > stzh-cell > stzh-checkboxgroup),
  ::slotted(stzh-row[span-large] > stzh-cell > stzh-dropdown),
  ::slotted(stzh-row[span-large] > stzh-cell > stzh-radio),
  ::slotted(stzh-row[span-large] > stzh-cell > stzh-amount),
  ::slotted(stzh-row[span-large] > stzh-cell > stzh-radiogroup) {
    @include mq($to: large) {
      @include spaceCurve("margin-bottom", "tiny");
    }
  }

  ::slotted(stzh-row[span-medium] > stzh-cell > stzh-input),
  ::slotted(stzh-row[span-medium] > stzh-cell > stzh-datepicker),
  ::slotted(stzh-row[span-medium] > stzh-cell > stzh-upload),
  ::slotted(stzh-row[span-medium] > stzh-cell > stzh-checkbox),
  ::slotted(stzh-row[span-medium] > stzh-cell > stzh-checkboxgroup),
  ::slotted(stzh-row[span-medium] > stzh-cell > stzh-dropdown),
  ::slotted(stzh-row[span-medium] > stzh-cell > stzh-radio),
  ::slotted(stzh-row[span-medium] > stzh-cell > stzh-amount),
  ::slotted(stzh-row[span-medium] > stzh-cell > stzh-radiogroup) {
    @include mq($to: medium) {
      @include spaceCurve("margin-bottom", "tiny");
    }
  }

  ::slotted(stzh-row[span-small] > stzh-cell > stzh-input),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-datepicker),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-upload),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-checkbox),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-checkboxgroup),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-dropdown),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-radio),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-amount),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-radiogroup) {
    @include mq($from: small, $to: medium) {
      @include spaceCurve("margin-bottom", "small");
    }
  }

  ::slotted(stzh-row[span-small] > stzh-cell > stzh-input),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-datepicker),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-upload),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-checkbox),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-checkboxgroup),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-dropdown),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-radio),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-amount),
  ::slotted(stzh-row[span-small] > stzh-cell > stzh-radiogroup) {
    @include mq($to: small) {
      @include spaceCurve("margin-bottom", "small");
    }
  }
}

.stzh-fieldset {
  //--stzh-row-row-gap: #{space('xsmall')};
  --stzh-description-min-height: #{$fieldsetDescriptionMinHeight};

  margin: 0;
  padding: 0;
  border: none;
  min-inline-size: auto;

  &__wrapper {
    display: grid;
  }

  &__legend {
    @include font("title");
    @include fontCurve("h4");
    color: $colorPrimary70;
    padding: 0;
    margin-bottom: space("large");
  }

  &--hide-legend &__legend {
    @include visuallyhidden;
  }
}
